import './style.scss';

import React, { FC, useState } from 'react';

import { ReactComponent as IconCarretDown } from 'assets/img/icons/icon_carret-Down.svg';

type AccordionProps = {
	title: string;
	expand?: boolean;
	children: React.ReactNode;
};

const Accordion: FC<AccordionProps> = ({ title, children, expand = false }) => {
	const [expanded, setExpanded] = useState(expand);

	const handleToggle = () => {
		setExpanded(!expanded);
	};

	return (
		<div className="accordion">
			<div className={`accordion__header ${expanded ? 'expanded' : ''}`} onClick={handleToggle}>
				<p className="accordion__title">{title}</p>
				<div className={`accordion__icon ${expanded ? 'expanded' : ''}`}>
					<IconCarretDown fill='#1956A8' width={14} />

				</div>
			</div>
			{expanded && <div className="accordion__content">{children}</div>}
		</div>
	);
};

export default Accordion;
